import MuiCheckbox, { CheckboxProps } from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Controller, UseControllerProps } from "react-hook-form";
import { getIsMobile } from "../../utils/helpers";

export type CustomCheckboxProps = UseControllerProps &
  CheckboxProps & {
    label: string;
  };

const Checkbox = (props: CustomCheckboxProps) => {
  const { control, name, label, sx, ...rest } = props;
  const isMobile = getIsMobile();
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <FormControlLabel
          control={
            <MuiCheckbox
              {...field}
              {...rest}
              checked={field.value}
              size={isMobile ? "large" : "medium"}
              sx={{ ...rippleStyles, ...sx }}
            />
          }
          label={label}
          sx={{ mx: 0, gap: 0.5 }}
        />
      )}
    />
  );
};

const rippleStyles = {
  paddingY: 0.7,
  paddingX: 0.15,
  height: "14px",
  "& .MuiTouchRipple-root": {
    borderRadius: 0, // Set the border radius to a smaller value to keep it boxy
  },
  "& .MuiTouchRipple-ripple": {
    borderRadius: 0, // Adjust the ripple shape to be less round and more box-like
  },
  "& .MuiTouchRipple-child": {
    borderRadius: 0,
    backgroundColor: "primary.main", // Customize the ripple color
  },
};
export default Checkbox;
